import React from 'react';

interface ImagePreviewProps {
  isOpen: boolean;
  onClose: () => void;
  imageSrc: string;
  imageAlt?: string;
  title?: string;
}

const ImagePreview: React.FC<ImagePreviewProps> = ({
  isOpen,
  onClose,
  imageSrc,
  imageAlt = '',
  title
}) => {
  if (!isOpen) return null;

  // Prevent click propagation to avoid closing when clicking on the image or title
  const handleContentClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <div 
      className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4 backdrop-blur-sm"
      onClick={onClose}
      aria-modal="true"
      role="dialog"
    >
      <div 
        className="relative max-w-4xl w-full animate-fade-in"
        onClick={handleContentClick}
      >
        <button 
          className="absolute -top-12 right-0 text-white hover:text-gray-300 transition-colors"
          onClick={onClose}
          aria-label="Close preview"
        >
          <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <div className="bg-black/50 p-2 rounded-lg">
          <img 
            src={imageSrc} 
            alt={imageAlt} 
            className="w-full h-auto max-h-[75vh] object-contain rounded"
          />
          {title && (
            <h3 className="text-white text-xl font-medium mt-4 text-center">
              {title}
            </h3>
          )}
        </div>
      </div>
    </div>
  );
};

export default ImagePreview;
